import { AuthService } from '../../service/auth.service';
import { Component, OnInit,ViewContainerRef } from '@angular/core';
import { FormBuilder,FormGroup,Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {AngularFirestore,AngularFirestoreCollection} from '@angular/fire/firestore';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import 'rxjs/add/operator/map';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent implements OnInit {
  image: File;
  privacyForm:FormGroup;
  privacy_image:any ;
  privacy_image_url:any ='';
  FOLDER: any = 'Privacy/';
  loading: any = false;
   edit: any = false;
  id: any;
  error: any = '';
  constructor(private form:FormBuilder,private router:Router ,private afs:AngularFirestore,private auth: AuthService,
    public toastr: ToastsManager,vcr: ViewContainerRef) {
      this.toastr.setRootViewContainerRef(vcr);
     }

     ngOnInit() {
      this.privacyForm = this.form.group({
        content: ['', [Validators.required]],
        upload_Image: ['', []]
      });
      this.checkdata();
    }
    async checkdata() {
      try {
        const privacydata = await this.afs.collection('/Privacy').valueChanges();
        privacydata.subscribe(privacydata => {
          console.log(privacydata);
  
          if (privacydata.length >= 1) {
            this.privacyForm.get('content').setValue(privacydata[0]['heading']);
            this.privacy_image_url = privacydata[0]['imageurl'];
            this.edit = true;
            this.id = privacydata[0]['id'];
          }
        });
      } catch (error) {
        this.error = 'Somthing went wrong please try later';
        this.toastr.error('Somthing went wrong please try later', 'Oops!');
        console.log(error);
      }
    }
    changeListner2(event) {
      this.image = <File>event.target.files[0];
    }

    async addprivacy(value, valid) {
      this.error = '';
      if (valid || this.edit) {
        this.loading = true;
        try {
          let uploadedimage;
          if (this.edit) {
            if (this.image) {
              uploadedimage = await this.auth.uploadimage(this.FOLDER, this.image, false);
              await this.afs.doc('Privacy/' + this.id).update({ heading: value.content, imageurl: uploadedimage['Location'] });
            } else {
              await this.afs.doc('Privacy/' + this.id).update({ heading: value.content });
            }
          } else {
            if (!this.image) {
              this.error = 'Image is required';
              this.toastr.error('Image is required!', 'Oops!');
            }
            uploadedimage = await this.auth.uploadimage(this.FOLDER, this.image, false);
            const addprivacy = await this.afs.collection('Privacy')
              .add({ heading: value.content, imageurl: uploadedimage['Location'], type: 'mobile' });
            const id = addprivacy.id;
            await this.afs.doc(`/Privacy/${id}`).update({ id: id });
          }
          this.loading = false;
          this.toastr.success('Privacy policy Updated!', 'Success!');
  
        } catch (error) {
          this.loading = false;
          this.toastr.error('Somthing went wrong please try later!', 'Oops!');
          console.log(error);
        }
      }
    }

}



// WEBPACK FOOTER //
// ./src/app/extras/privacy-policy/privacy-policy.component.ts